import { useSuspenseInfiniteQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

interface GetPublicStudySetsParams {
  subject?: string;
  search?: string;
  cursor?: string;
  limit?: number;
}

// Infinite query hook for infinite scroll
export const useInfinitePublicStudySets = (
  params: Omit<GetPublicStudySetsParams, "cursor"> = {},
) => {
  const trpc = useTRPC();
  return useSuspenseInfiniteQuery(
    trpc.studysets.getPublic.infiniteQueryOptions(
      {
        limit: params.limit ?? 12,
        subject: params.subject,
        // cursor: params.cursor,
        search: params.search,
      },
      {
        getNextPageParam: (lastPage) => lastPage.nextCursor,
        staleTime: Number.POSITIVE_INFINITY,
      },
    ),
  );
};
